import { connect } from 'react-redux';
import CalendarEventsAdminScreen from '../components/CalendarEventsAdminScreen';
import storage from '../../../../../lib/Storage';
import { findStorageType } from '../../../../../lib/Auth';

const mapStateToProps = (state) => {
  return {
    total: state.calendarEventsAdmin.get('total'),
    isLoading: state.calendarEventsAdmin.get('isLoading'),
    activeId: storage.get(findStorageType(), 'partnershipId'),
    access_role_admin_in_app: storage.get(findStorageType(), 'partnershipData')
      ?.access_role_admin_in_app,
    partnershipId: storage.get(findStorageType(), 'partnershipId'),
    partnershipName: storage.get(findStorageType(), 'partnershipData')?.name,
    role: storage.get(findStorageType(), 'partnershipData')?.role,
  };
};

const CalendarEventsAdminScreenContainer = connect(mapStateToProps)(
  CalendarEventsAdminScreen
);

export default CalendarEventsAdminScreenContainer;
